// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"bec1437b","117":"7602968d","119":"0c76d290","305":"e96e5801","367":"d2c477ea","444":"8d35671a","453":"fedf51c0","585":"ea24f528","647":"92dbc642","649":"b75cea96","741":"5c6fe7be","762":"3001f9dc","835":"5800a32f","855":"1c7fcea5","895":"7479eeab","981":"3f731c8a"}[chunkId] + ".chunk.js";
};